import { IFieldInstance } from "../../types/fieldInstance.interface";
import { findFormfieldById } from "./hashTable";

export const getChildFields = (
  childFieldIds: string[],
  targetFieldType: string,
  relatedListName?: string
) => {
  const childFields: IFieldInstance[] = [];
  childFieldIds.forEach((childId: string) => {
    const child = findFormfieldById(childId, relatedListName);
    if (child.fieldType === targetFieldType) {
      childFields.push(child);
    } else {
      return;
    }
  });
  return childFields;
};
